import { Icon } from "@iconify/react";
import { Button } from "@heroui/react";

interface FavoriteProps {
    favorite?: boolean;
    callback?: (event: any) => void;
    className?: string;
}

export default function FavoriteIcon({ favorite = false, callback, className }: FavoriteProps) {
    return (
        <>
            <Button
                as="div"
                className={"h-[30px] w-[30px] min-h-[30px] min-w-[30px] flex items-center rounded-medium justify-center bg-transparent p-0 m-0 " + (className || '')}
                onClick={callback ? callback : () => { }}
            >
                {favorite ? (
                    <Icon
                        className="text-yellow-500 text-2xl"
                        icon="mdi:star"
                    />
                ) : (
                    <Icon
                        className="text-default-500 text-2xl"
                        icon="mdi:star-outline"
                    />
                )}
            </Button>
        </>
    );
}
